var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.99997 15V3.82998L13.88 8.70998C14.27 9.09998 14.91 9.09998 15.3 8.70998C15.69 8.31998 15.69 7.68998 15.3 7.29998L8.70997 0.70998C8.31997 0.31998 7.68997 0.31998 7.29997 0.70998L0.699971 7.28998C0.309971 7.67998 0.309971 8.30998 0.699971 8.69998C1.08997 9.08998 1.71997 9.08998 2.10997 8.69998L6.99997 3.82998V15C6.99997 15.55 7.44997 16 7.99997 16C8.54997 16 8.99997 15.55 8.99997 15Z","fill":"#334155"}));
}

Icon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Icon;

Icon.default = Icon;
